"use client";

export function Stepper({
  current,
  total = 3
}: {
  current: number;
  total?: number;
}) {
  return (
    <div className="flex items-center gap-3 mb-6">
      <div className="flex items-center gap-[5px]">
        {Array.from({ length: total }, (_, idx) => idx + 1).map((i) => (
          <div
            key={i}
            className={
              i === current
                ? "h-1.5 w-[18px] rounded-[3px] bg-bubblegum transition-all duration-250"
                : i < current
                  ? "h-1.5 w-1.5 rounded-full bg-bubblegum scale-[1.1] transition-all duration-250"
                  : "h-1.5 w-1.5 rounded-full bg-border transition-all duration-250"
            }
          />
        ))}
      </div>
      <span className="text-xs font-body font-semibold text-text-muted uppercase tracking-wider">
        Step <span>{current}</span> of {total}
      </span>
    </div>
  );
}
